import { ReactElement } from 'react'

import Avatar from '@mui/material/Avatar'
import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import Chip from '@mui/material/Chip'
import Divider from '@mui/material/Divider'
import IconButton from '@mui/material/IconButton'
import Typography from '@mui/material/Typography'

import { CloseIcon } from 'src/v3/core/icons'

import theme from 'src/theme'
import { UserExtra as User } from 'src/user/user.types'

interface Props {
  entity: User
  onCancel: () => void
}

let UserCard = ({ entity, onCancel }: Props): ReactElement => (
  <Card variant="outlined" className="p-3">
    <Box className="flex px-2 mb-2 justify-content-between items-center">
      <div className="flex justify-center items-center my-2">
        <Avatar sx={{ bgcolor: theme.palette.primary.main }}>
          {`${entity.firstName[0]}${entity.lastName[0]}`.toUpperCase()}
        </Avatar>
        <Typography className="pl-2">{entity.name}</Typography>
      </div>
      <IconButton
        edge="end"
        aria-label="close"
        onClick={onCancel}
        sx={{ marginTop: -3, marginLeft: 2 }}
      >
        <CloseIcon />
      </IconButton>
    </Box>
    <Box
      sx={{
        padding: 0,
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: 3,
      }}
    >
      <div style={{ padding: 12, overflowWrap: 'break-word' }}>
        <div className="font-weight-bold">Email</div>
        <div>{entity.primaryEmail}</div>
      </div>
      <Divider />
      <div style={{ padding: 12 }}>
        <div className="font-weight-bold">Roles</div>
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: 5,
            marginTop: 5,
          }}
        >
          {entity.roles?.map((role) => <Chip key={role} label={role} />) ||
            'None'}
        </div>
      </div>
    </Box>
  </Card>
)

export default UserCard
